"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var regexHrefOpenTag = new RegExp(/<a(.|\n)*?>/);
var regexHrefCloseTag = new RegExp(/<\/a(.|\n)*?>/);
var translateConsents = function translateConsents(consentContent, t) {
  var openTagContent = regexHrefOpenTag.exec(consentContent);
  var closeTagContent = regexHrefCloseTag.exec(consentContent);
  if (openTagContent) {
    var modifiedConsentContent = consentContent.replace(regexHrefOpenTag, '{{htmltag}}');
    modifiedConsentContent = modifiedConsentContent.replace(regexHrefCloseTag, '{{endhtmltag}}');
    return "".concat(t(modifiedConsentContent, {
      htmltag: openTagContent[0],
      endhtmltag: closeTagContent[0]
    }));
  }
  return t(consentContent);
};
var _default = translateConsents;
exports.default = _default;